(function() {
  'use strict';

  if (window.PillSearchEngine) return;

  function cfg() { return window.PillConfig || {}; }

  /* ===== Cologne Phonetics ===== */
  function colognePhonetics(word) {
    if (!word) return '';
    word = word.toUpperCase().replace(/[^A-ZÄÖÜß]/g, '');
    word = word.replace(/Ä/g, 'AE').replace(/Ö/g, 'OE').replace(/Ü/g, 'UE').replace(/ß/g, 'SS');
    var len = word.length;
    if (len === 0) return '';
    var codes = [];
    for (var i = 0; i < len; i++) {
      var c = word[i];
      var prev = i > 0 ? word[i - 1] : '';
      var next = i < len - 1 ? word[i + 1] : '';
      var code = -1;
      switch (c) {
        case 'A': case 'E': case 'I': case 'J': case 'O': case 'U': case 'Y':
          code = 0; break;
        case 'H':
          code = -1; break;
        case 'B': code = 1; break;
        case 'P':
          code = (next === 'H') ? 3 : 1; break;
        case 'D': case 'T':
          code = ('CSZ'.indexOf(next) >= 0) ? 8 : 2; break;
        case 'F': case 'V': case 'W':
          code = 3; break;
        case 'G': case 'K': case 'Q':
          code = 4; break;
        case 'C':
          if (i === 0) {
            code = ('AHKLOQRUX'.indexOf(next) >= 0) ? 4 : 8;
          } else {
            code = ('SZ'.indexOf(prev) >= 0) ? 8 : (('AHKOQUX'.indexOf(next) >= 0) ? 4 : 8);
          }
          break;
        case 'X':
          code = ('CKQ'.indexOf(prev) >= 0) ? 8 : 48; break;
        case 'L': code = 5; break;
        case 'M': case 'N': code = 6; break;
        case 'R': code = 7; break;
        case 'S': case 'Z': code = 8; break;
      }
      if (code === 48) { codes.push(4); codes.push(8); }
      else if (code >= 0) { codes.push(code); }
    }
    var result = [codes[0]];
    for (var j = 1; j < codes.length; j++) {
      if (codes[j] !== codes[j - 1]) result.push(codes[j]);
    }
    if (result.length > 1 && result[0] === 0) result.shift();
    return result.join('');
  }

  /* ===== Levenshtein distance ===== */
  function levenshtein(a, b) {
    var m = a.length, n = b.length;
    if (m === 0) return n;
    if (n === 0) return m;
    var prev = [], curr = [];
    for (var j = 0; j <= n; j++) prev[j] = j;
    for (var i = 1; i <= m; i++) {
      curr[0] = i;
      for (var j2 = 1; j2 <= n; j2++) {
        var cost = a[i - 1] === b[j2 - 1] ? 0 : 1;
        curr[j2] = Math.min(prev[j2] + 1, curr[j2 - 1] + 1, prev[j2 - 1] + cost);
      }
      prev = curr.slice();
    }
    return prev[n];
  }

  function formatEuro(amount) {
    return amount.toFixed(2).replace('.', ',') + ' \u20ac';
  }

  /** Exclude digital / non-physical variants from price + availability (same rule everywhere). */
  function isSellableVariantTitle(title) {
    if (!title) return true;
    return title.toLowerCase().indexOf('digital') < 0;
  }

  function pickCheapestSellable(variants) {
    var cheapest = Infinity;
    var count = 0;
    if (!variants) return { cheapest: null, count: 0 };
    variants.forEach(function(v) {
      if (!isSellableVariantTitle(v.title)) return;
      count++;
      if (v.price < cheapest) cheapest = v.price;
    });
    return { cheapest: cheapest < Infinity ? cheapest : null, count: count };
  }

  function escapeGraphqlString(s) {
    return String(s).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  /** Metafields use both "Filmtablette" and "Filmtabletten" — one filter option. */
  function canonicalDarreichungsform(raw) {
    if (raw == null || raw === '') return '';
    var t = String(raw).trim();
    var l = t.toLowerCase();
    if (l === 'filmtablette' || l === 'filmtabletten') return 'Filmtabletten';
    return t;
  }

  /**
   * Wirkstoff strings like "Chlormadinone:2000;Ethinylestradiol:30" — group filter options
   * by substance names (ignore doses). Same combo with different strengths = one category.
   */
  function wirkstoffSegments(raw) {
    if (raw == null || raw === '') return [];
    return String(raw)
      .split(';')
      .map(function(s) { return s.trim(); })
      .filter(Boolean);
  }

  function wirkstoffSubstanceKeyFromName(name) {
    return String(name || '').trim().toLowerCase();
  }

  /** Single substance names from a raw Wirkstoff / product_type string (semicolons, optional dose, + combos). */
  function substanceNamesFromRaw(raw) {
    if (raw == null || raw === '') return [];
    var segs = wirkstoffSegments(raw);
    if (segs.length === 0) segs = [String(raw).trim()].filter(Boolean);
    var names = [];
    segs.forEach(function(seg) {
      String(seg)
        .split('+')
        .forEach(function(part) {
          part = part.trim();
          if (!part) return;
          var idx = part.indexOf(':');
          var name = (idx >= 0 ? part.slice(0, idx) : part).trim();
          if (name) names.push(name);
        });
    });
    return names;
  }

  /** @return {Object<string, true>} key map for one product row */
  function wirkstoffSubstanceKeyMapFromRaw(raw) {
    var map = {};
    substanceNamesFromRaw(raw).forEach(function(n) {
      var k = wirkstoffSubstanceKeyFromName(n);
      if (k) map[k] = true;
    });
    return map;
  }

  /** @param {Set<string>} rawSet */
  function collectUniqueSubstancesFromRawSet(rawSet) {
    var keyToLabel = {};
    Array.from(rawSet).forEach(function(w) {
      if (!w) return;
      substanceNamesFromRaw(w).forEach(function(name) {
        var k = wirkstoffSubstanceKeyFromName(name);
        if (!k) return;
        if (!keyToLabel[k]) keyToLabel[k] = name;
      });
    });
    return Object.keys(keyToLabel)
      .sort(function(a, b) { return keyToLabel[a].localeCompare(keyToLabel[b], 'de'); })
      .map(function(k) {
        return { key: k, label: keyToLabel[k] };
      });
  }

  /** Union of Wirkstoff strings from enriched map and trigger rows. */
  function collectAllWirkstoffRawSet(triggers, enriched) {
    var wirkstoffe = new Set();
    if (enriched) {
      Object.keys(enriched).forEach(function(h) {
        if (enriched[h].wirkstoff) wirkstoffe.add(enriched[h].wirkstoff);
      });
    }
    (triggers || []).forEach(function(t) {
      if (t.wirkstoff) wirkstoffe.add(t.wirkstoff);
    });
    return wirkstoffe;
  }

  function navigateToVariant(handle) {
    window.location.href = (cfg().variantPageUrl || '/pages/verhuetung-varianten') + '?trigger=' + encodeURIComponent(handle);
  }

  /* ===== Search Instance ===== */
  function SearchInstance(sectionId) {
    this.id = sectionId;
    this.triggerData = null;
    this.enrichedData = null;
    this.priceCache = {};
    this.activeFilters = { wirkstoffSubstanceKeys: [], darreichungsformValues: [], letter: '', sort: 'name-asc' };
    this.isFilterView = false;
    this._timer = null;
    this._el = {};
  }

  SearchInstance.prototype.getUiStrings = function() {
    var root = this._el.root;
    if (!root || !root.dataset) {
      return {
        emptyFilter: 'Dein Medikament nicht gefunden?',
        oosBadge: 'Aktuell nicht verf\u00fcgbar',
        alternativesLabel: 'Generische Alternative'
      };
    }
    return {
      emptyFilter: root.dataset.emptyFilterMessage || 'Dein Medikament nicht gefunden?',
      oosBadge: root.dataset.oosBadgeText || 'Aktuell nicht verf\u00fcgbar',
      alternativesLabel: root.dataset.alternativesLabel || 'Generische Alternative'
    };
  };

  SearchInstance.prototype.cacheElements = function() {
    var id = this.id;
    var root = document.getElementById('pill-finder-' + id);
    if (!root) return;
    this._el = {
      root: root,
      input: document.getElementById('pill-search-input-' + id),
      results: document.getElementById('pill-results-' + id),
      status: document.getElementById('pill-search-status-' + id),
      filterZone: document.getElementById('pill-filter-zone-' + id),
      filterGrid: document.getElementById('pill-filter-grid-' + id),
      wirkstoffGroup: document.getElementById('pill-filter-wirkstoff-group-' + id),
      darreichungsformGroup: document.getElementById('pill-filter-darreichungsform-group-' + id),
      sortGroup: document.getElementById('pill-filter-sort-group-' + id),
      filterToggle: root.querySelector('.pill-finder__filter-toggle'),
      searchWrap: root.querySelector('.pill-finder__search-wrap'),
      azBar: root.querySelector('.pill-finder__az-bar')
    };
  };

  SearchInstance.prototype.loadTriggerData = function(cb) {
    var self = this;
    if (self.triggerData) return cb(self.triggerData);
    fetch(cfg().triggerDataUrl)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data || !Array.isArray(data.triggers)) {
          console.error('[pill-finder] malformed trigger data');
          return;
        }
        self.triggerData = data;
        data.triggers.forEach(function(t) { t._phonetic = colognePhonetics(t.trigger); });
        cb(data);
      })
      .catch(function(err) { console.error('[pill-finder] Failed to load trigger data', err); });
  };

  SearchInstance.prototype.searchTriggers = function(query, triggers) {
    if (!query || query.length < 2) return [];
    var q = query.trim().toLowerCase();
    var qPhonetic = colognePhonetics(q);
    var results = [];
    triggers.forEach(function(t) {
      var name = t.trigger.toLowerCase();
      if (name.indexOf(q) === 0) { results.push({ trigger: t, score: 0 }); return; }
      if (name.indexOf(q) >= 0) { results.push({ trigger: t, score: 1 }); return; }
      if (qPhonetic.length >= 2 && t._phonetic.indexOf(qPhonetic) === 0) { results.push({ trigger: t, score: 2 }); return; }
      var dist = levenshtein(q, name);
      if (dist <= 2) results.push({ trigger: t, score: 3 + dist });
    });
    results.sort(function(a, b) { return a.score - b.score; });
    return results.slice(0, 8);
  };

  SearchInstance.prototype.renderResults = function(results) {
    var container = this._el.results;
    var statusEl = this._el.status;
    var self = this;
    container.innerHTML = '';
    if (results.length === 0) {
      container.hidden = true;
      statusEl.textContent = 'Keine Ergebnisse gefunden';
      return;
    }
    container.hidden = false;
    statusEl.textContent = results.length + ' Ergebnis' + (results.length > 1 ? 'se' : '') + ' gefunden';

    results.forEach(function(r) {
      var t = r.trigger;
      var item = document.createElement('div');
      item.className = 'pill-finder__result-item';
      item.setAttribute('role', 'option');
      item.setAttribute('tabindex', '0');
      item.dataset.handle = t.handle;

      var thumbWrap = document.createElement('div');
      thumbWrap.className = 'pill-finder__result-thumb';
      var thumb = document.createElement('img');
      thumb.alt = '';
      thumb.loading = 'lazy';
      thumbWrap.appendChild(thumb);
      item.appendChild(thumbWrap);

      var textCol = document.createElement('div');
      textCol.className = 'pill-finder__result-text';
      var nameRow = document.createElement('div');
      nameRow.className = 'pill-finder__result-name-row';
      var nameEl = document.createElement('span');
      nameEl.className = 'pill-finder__result-name';
      nameEl.textContent = t.trigger;
      nameRow.appendChild(nameEl);
      textCol.appendChild(nameRow);
      var metaEl = document.createElement('span');
      metaEl.className = 'pill-finder__result-meta';
      metaEl.textContent = t.wirkstoff || '';
      textCol.appendChild(metaEl);
      item.appendChild(textCol);

      var priceEl = document.createElement('span');
      priceEl.className = 'pill-finder__result-price';
      item.appendChild(priceEl);

      function applyEnrichedRow(enr) {
        if (!enr) return;
        if (enr.title) {
          nameEl.textContent = enr.title;
          thumb.alt = enr.title;
        }
        if (enr.image) { thumb.src = enr.image; }
        if (enr.wirkstoff) metaEl.textContent = enr.wirkstoff;
        var picked = pickCheapestSellable(enr.variants);
        if (picked.cheapest != null) {
          self.priceCache[t.handle] = picked.cheapest;
          priceEl.textContent = (picked.count > 1 ? 'ab ' : '') + formatEuro(picked.cheapest);
        } else {
          priceEl.textContent = '';
        }
      }

      /* Use enriched data if available, otherwise fetch via AJAX API */
      var enr = self.enrichedData && self.enrichedData[t.handle];
      if (enr) {
        applyEnrichedRow(enr);
      } else {
        (function(handle, thumbEl, priceElement) {
          fetch('/products/' + handle + '.json')
            .then(function(resp) { return resp.ok ? resp.json() : null; })
            .then(function(data) {
              if (!data || !data.product) return;
              var p = data.product;
              if (p.images && p.images.length > 0) {
                thumbEl.src = p.images[0].src;
                thumbEl.alt = p.title;
              }
              nameEl.textContent = p.title || nameEl.textContent;
              var variants = (p.variants || []).map(function(v) {
                return { title: v.title, price: parseFloat(v.price) };
              });
              var picked = pickCheapestSellable(variants);
              if (picked.cheapest != null) {
                self.priceCache[handle] = picked.cheapest;
                priceElement.textContent = (picked.count > 1 ? 'ab ' : '') + formatEuro(picked.cheapest);
              }
              if (p.product_type) metaEl.textContent = p.product_type;
            })
            .catch(function() {});
        })(t.handle, thumb, priceEl);
      }

      if (t.alternatives && t.alternatives.length > 0) {
        var altWrap = document.createElement('div');
        altWrap.className = 'pill-finder__result-alts';
        var uiAlts = self.getUiStrings();
        var altLabel = document.createElement('span');
        altLabel.className = 'pill-finder__result-alts-label';
        altLabel.textContent = uiAlts.alternativesLabel;
        altWrap.appendChild(altLabel);
        t.alternatives.forEach(function(alt) {
          var altBtn = document.createElement('button');
          altBtn.type = 'button';
          altBtn.className = 'pill-finder__alt-btn';
          altBtn.textContent = alt.title;
          altBtn.dataset.handle = alt.handle;
          altBtn.addEventListener('click', function(e) { e.stopPropagation(); navigateToVariant(alt.handle); });
          altWrap.appendChild(altBtn);
        });
        item.appendChild(altWrap);
      }

      item.addEventListener('click', function() { navigateToVariant(t.handle); });
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigateToVariant(t.handle); }
      });
      container.appendChild(item);
    });

  };

  SearchInstance.prototype.enrichFiltersFromAPI = function(cb) {
    var self = this;
    var boot = cfg().enrichedBootstrap;
    if (boot && typeof boot === 'object' && Object.keys(boot).length > 0) {
      self.enrichedData = boot;
      if (cb) cb(self.enrichedData);
      return;
    }
    console.warn('[pill-finder] enrichedBootstrap is empty — verify pill_collection_handle setting + that the collection is published to the Online Store sales channel. Falling back to Storefront API.');
    var handle = cfg().collectionHandle || 'contraceptives-new';
    var cacheKey = 'pill_enriched_v4_' + handle;
    var cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      self.enrichedData = JSON.parse(cached);
      if (cb) cb(self.enrichedData);
      return;
    }
    var esc = escapeGraphqlString(handle);
    var query =
      '{ collection(handle: "' + esc + '") { products(first: 250) { edges { node { handle title productType featuredImage { url } darreichungsformMF: metafield(namespace: "custom", key: "darreichungsform") { value } wirkstoffMF: metafield(namespace: "custom", key: "wirkstoff") { value } variants(first: 20) { edges { node { title price { amount } } } } } } } }';
    fetch(cfg().graphqlUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg().storefrontToken },
      body: JSON.stringify({ query: query })
    })
    .then(function(r) {
      if (!r.ok) console.error('[pill-finder] Storefront fetch HTTP ' + r.status + ' — token may not be valid for this store (E8). Filters will stay empty.');
      return r.json();
    })
    .then(function(resp) {
      if (resp.errors && resp.errors.length) {
        console.error('[pill-finder] Storefront GraphQL errors', resp.errors);
      }
      self.enrichedData = {};
      var products = resp.data && resp.data.collection && resp.data.collection.products;
      if (products && products.edges && products.edges.length) {
        products.edges.forEach(function(edge) {
          var node = edge.node;
          if (!node || !node.handle) return;
          var pt = (node.productType && String(node.productType).trim()) || '';
          var wMeta =
            node.wirkstoffMF && node.wirkstoffMF.value ? String(node.wirkstoffMF.value).trim() : '';
          var dFormVal =
            node.darreichungsformMF && node.darreichungsformMF.value
              ? String(node.darreichungsformMF.value).trim()
              : '';
          var d = {
            wirkstoff: pt || wMeta,
            darreichungsform: dFormVal,
            price: null,
            image: null,
            title: node.title,
            variants: []
          };
          if (node.featuredImage) d.image = node.featuredImage.url;
          if (node.variants && node.variants.edges.length > 0) {
            d.variants = node.variants.edges.map(function(e) {
              return {
                title: e.node.title,
                price: parseFloat(e.node.price.amount)
              };
            });
            var picked = pickCheapestSellable(d.variants);
            d.price = picked.cheapest;
          }
          self.enrichedData[node.handle] = d;
        });
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify(self.enrichedData));
        } catch (e) { /* quota / private mode */ }
      } else {
        try {
          sessionStorage.removeItem(cacheKey);
        } catch (e2) { /* ignore */ }
      }
      if (cb) cb(self.enrichedData);
    })
    .catch(function(err) {
      console.error('[pill-finder] Storefront enrichment failed', err);
      try {
        sessionStorage.removeItem(cacheKey);
      } catch (e) { /* ignore */ }
      if (cb) cb({});
    });
  };

  /* Returns the count-based summary text for a multi-select dropdown.
     `emptyAttr` and `countAttr` name the data-* attrs on root that override the defaults. */
  SearchInstance.prototype.getMultiSummaryText = function(count, emptyAttr, countAttr, defaultEmpty, defaultCount) {
    var root = this._el.root;
    var emptyText = defaultEmpty;
    var countTpl = defaultCount;
    if (root && root.dataset) {
      if (root.dataset[emptyAttr]) emptyText = root.dataset[emptyAttr];
      if (root.dataset[countAttr]) countTpl = root.dataset[countAttr];
    }
    if (count <= 0) return emptyText;
    return countTpl.replace(/\{count\}/g, String(count));
  };

  /* Generic updater for any filter dropdown's summary line.
     `kind` controls how the count \u2192 text mapping works:
       - 'wirkstoff'        \u2192 count-based, data-wirkstoff-summary-{empty,count}
       - 'darreichungsform' \u2192 count-based, data-darreichungsform-summary-{empty,count}
       - 'sort'             \u2192 label-based; reads data-sort-summary-prefix + the selected radio's label */
  SearchInstance.prototype.updateMultiDropdownSummaryDom = function(kind) {
    var mount = this._el[kind === 'wirkstoff' ? 'wirkstoffGroup'
              : kind === 'darreichungsform' ? 'darreichungsformGroup'
              : 'sortGroup'];
    if (!mount) return;
    var span = mount.querySelector('.pill-finder__multi-dropdown-summary-text');
    if (!span) return;

    if (kind === 'sort') {
      var checked = mount.querySelector('input[type="radio"][data-filter="sort"]:checked');
      var labelText = '';
      if (checked) {
        var labelEl = mount.querySelector('label[for="' + checked.id + '"]');
        if (labelEl) labelText = labelEl.textContent;
      }
      var prefix = (this._el.root && this._el.root.dataset && this._el.root.dataset.sortSummaryPrefix) || '';
      span.textContent = (prefix ? prefix + ' ' : '') + labelText;
      return;
    }

    var selector = kind === 'wirkstoff'
      ? 'input[type="checkbox"][data-wirkstoff-substance-key]:checked'
      : 'input[type="checkbox"][data-filter="darreichungsform"]:checked';
    var n = mount.querySelectorAll(selector).length;

    if (kind === 'wirkstoff') {
      span.textContent = this.getMultiSummaryText(n, 'wirkstoffSummaryEmpty', 'wirkstoffSummaryCount', 'Wirkstoff filtern', '{count} ausgew\u00e4hlt');
    } else {
      span.textContent = this.getMultiSummaryText(n, 'darreichungsformSummaryEmpty', 'darreichungsformSummaryCount', 'Darreichungsform filtern', '{count} ausgew\u00e4hlt');
    }
  };

  SearchInstance.prototype.syncWirkstoffSubstanceKeysFromDom = function() {
    var group = this._el.wirkstoffGroup;
    if (!group) return;
    var keys = [];
    group.querySelectorAll('input[type="checkbox"][data-wirkstoff-substance-key]:checked').forEach(function(cb) {
      keys.push(cb.dataset.wirkstoffSubstanceKey);
    });
    this.activeFilters.wirkstoffSubstanceKeys = keys;
  };

  SearchInstance.prototype.syncDarreichungsformValuesFromDom = function() {
    var group = this._el.darreichungsformGroup;
    if (!group) return;
    var values = [];
    group.querySelectorAll('input[type="checkbox"][data-filter="darreichungsform"]:checked').forEach(function(cb) {
      values.push(cb.value);
    });
    this.activeFilters.darreichungsformValues = values;
  };

  /* Builds a <details>-based dropdown with checkbox or radio rows into `mount`.
     opts: { type: 'checkbox' | 'radio', filterKey, idPrefix, name, options, currentValues, summaryId, ariaLabelledBy, dataAttrName } */
  SearchInstance.prototype.buildMultiDropdown = function(mount, opts) {
    mount.innerHTML = '';
    if (!opts.options || opts.options.length === 0) {
      var empty = document.createElement('p');
      empty.className = 'pill-finder__grid-empty';
      empty.style.paddingTop = 'var(--spacing-4)';
      empty.style.paddingBottom = 'var(--spacing-4)';
      empty.textContent = opts.emptyMessage || 'Keine Daten';
      mount.appendChild(empty);
      return false;
    }
    var details = document.createElement('details');
    details.className = 'pill-finder__multi-dropdown-details';
    var summary = document.createElement('summary');
    summary.className = 'pill-finder__filter-select';
    if (opts.summaryId) summary.id = opts.summaryId;
    var sumText = document.createElement('span');
    sumText.className = 'pill-finder__multi-dropdown-summary-text';
    summary.appendChild(sumText);
    var panel = document.createElement('div');
    panel.className = 'pill-finder__multi-dropdown-panel';
    panel.setAttribute('role', 'group');
    if (opts.ariaLabelledBy) panel.setAttribute('aria-labelledby', opts.ariaLabelledBy);

    var current = opts.currentValues || [];
    opts.options.forEach(function(o, idx) {
      var rowId = opts.idPrefix + '-' + idx;
      var row = document.createElement('div');
      row.className = 'pill-finder__multi-dropdown-row';
      var input = document.createElement('input');
      input.type = opts.type;
      input.id = rowId;
      input.value = o.key;
      input.dataset.filter = opts.filterKey;
      if (opts.dataAttrName) input.dataset[opts.dataAttrName] = o.key;
      if (opts.type === 'radio') input.name = opts.name;
      if (current.indexOf(o.key) >= 0) input.checked = true;
      var lab = document.createElement('label');
      lab.htmlFor = rowId;
      lab.className = 'pill-finder__multi-dropdown-row-label';
      lab.textContent = o.label;
      row.appendChild(input);
      row.appendChild(lab);
      panel.appendChild(row);
    });
    details.appendChild(summary);
    details.appendChild(panel);
    mount.appendChild(details);
    return true;
  };

  SearchInstance.prototype.populateFilters = function(triggers, enriched) {
    /* Darreichungsform + Sortierung dropdowns are built lazily via updateFilterSelects.
       This method now only initialises the A-Z bar; collected data is reused later. */
    var azBar = this._el.azBar;
    if (azBar && azBar.children.length === 0) {
      var letters = new Set();
      triggers.forEach(function(t) { letters.add(t.trigger.charAt(0).toUpperCase()); });
      'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function(l) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pill-finder__az-btn';
        btn.textContent = l;
        btn.dataset.letter = l;
        if (!letters.has(l)) { btn.disabled = true; btn.classList.add('pill-finder__az-btn--disabled'); }
        azBar.appendChild(btn);
      });
    }
  };

  SearchInstance.prototype.updateFilterSelects = function(enriched, triggers) {
    var self = this;
    var wirkstoffe = collectAllWirkstoffRawSet(triggers, enriched);
    var formen = new Set();
    if (enriched) {
      Object.keys(enriched).forEach(function(h) {
        if (enriched[h].darreichungsform) {
          formen.add(canonicalDarreichungsform(enriched[h].darreichungsform));
        }
      });
    }
    (triggers || []).forEach(function(t) {
      if (t.darreichungsform) formen.add(canonicalDarreichungsform(t.darreichungsform));
    });

    /* Wirkstoff dropdown */
    var wGroup = this._el.wirkstoffGroup;
    if (wGroup) {
      var wOpts = collectUniqueSubstancesFromRawSet(wirkstoffe);
      var built = this.buildMultiDropdown(wGroup, {
        type: 'checkbox',
        filterKey: 'wirkstoff',
        idPrefix: 'pill-wirkstoff-sub-' + self.id,
        options: wOpts,
        currentValues: (this.activeFilters.wirkstoffSubstanceKeys || []).slice(),
        summaryId: 'pill-wirkstoff-summary-' + self.id,
        ariaLabelledBy: 'pill-filter-wirkstoff-legend-' + self.id,
        dataAttrName: 'wirkstoffSubstanceKey',
        emptyMessage:
          enriched && typeof enriched === 'object' && Object.keys(enriched).length > 0
            ? 'Keine Wirkstoff-Daten'
            : 'Wird geladen\u2026'
      });
      if (!built) {
        this.activeFilters.wirkstoffSubstanceKeys = [];
      } else {
        this.syncWirkstoffSubstanceKeysFromDom();
        this.updateMultiDropdownSummaryDom('wirkstoff');
      }
    }

    /* Darreichungsform dropdown (multi-select checkboxes) */
    var dGroup = this._el.darreichungsformGroup;
    if (dGroup) {
      var dOpts = Array.from(formen).sort().map(function(f) { return { key: f, label: f }; });
      var dBuilt = this.buildMultiDropdown(dGroup, {
        type: 'checkbox',
        filterKey: 'darreichungsform',
        idPrefix: 'pill-darreichungsform-' + self.id,
        options: dOpts,
        currentValues: (this.activeFilters.darreichungsformValues || []).slice(),
        summaryId: 'pill-darreichungsform-summary-' + self.id,
        ariaLabelledBy: 'pill-filter-darreichungsform-legend-' + self.id,
        emptyMessage:
          enriched && typeof enriched === 'object' && Object.keys(enriched).length > 0
            ? 'Keine Darreichungsform-Daten'
            : 'Wird geladen\u2026'
      });
      if (!dBuilt) {
        this.activeFilters.darreichungsformValues = [];
      } else {
        this.syncDarreichungsformValuesFromDom();
        this.updateMultiDropdownSummaryDom('darreichungsform');
      }
    }

    /* Sortierung dropdown (single-select radios) */
    var sGroup = this._el.sortGroup;
    if (sGroup) {
      var sOpts = [
        { key: 'name-asc', label: 'Name A\u2013Z' },
        { key: 'name-desc', label: 'Name Z\u2013A' }
      ];
      var current = this.activeFilters.sort || 'name-asc';
      this.buildMultiDropdown(sGroup, {
        type: 'radio',
        filterKey: 'sort',
        idPrefix: 'pill-sort-' + self.id,
        name: 'pill-sort-' + self.id,
        options: sOpts,
        currentValues: [current],
        summaryId: 'pill-sort-summary-' + self.id,
        ariaLabelledBy: 'pill-filter-sort-legend-' + self.id
      });
      this.updateMultiDropdownSummaryDom('sort');
    }
  };

  SearchInstance.prototype.renderFilterGrid = function(triggers) {
    var grid = this._el.filterGrid;
    if (!grid) return;
    grid.innerHTML = '';
    var self = this;
    var filters = self.activeFilters;
    var enriched = self.enrichedData;
    var ui = self.getUiStrings();

    var filtered = triggers.filter(function(t) {
      if (filters.wirkstoffSubstanceKeys && filters.wirkstoffSubstanceKeys.length > 0) {
        var ew = enriched && enriched[t.handle] && enriched[t.handle].wirkstoff;
        var rawW = (ew || t.wirkstoff) || '';
        var pmap = wirkstoffSubstanceKeyMapFromRaw(rawW);
        for (var wi = 0; wi < filters.wirkstoffSubstanceKeys.length; wi++) {
          if (!pmap[filters.wirkstoffSubstanceKeys[wi]]) return false;
        }
      }
      if (filters.darreichungsformValues && filters.darreichungsformValues.length > 0) {
        var ed = enriched && enriched[t.handle] && enriched[t.handle].darreichungsform;
        var rawD = (ed || t.darreichungsform) || '';
        if (filters.darreichungsformValues.indexOf(canonicalDarreichungsform(rawD)) < 0) return false;
      }
      if (filters.letter && t.trigger.charAt(0).toUpperCase() !== filters.letter) return false;
      return true;
    });

    var sortMode = filters.sort || 'name-asc';
    filtered.sort(function(a, b) {
      if (sortMode === 'name-desc') return b.trigger.localeCompare(a.trigger);
      return a.trigger.localeCompare(b.trigger);
    });

    filtered.forEach(function(t) {
      var cell = document.createElement('div');
      cell.className = 'pill-finder__grid-cell';
      cell.setAttribute('role', 'listitem');

      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'pill-finder__grid-item';

      var thumbEl = document.createElement('div');
      thumbEl.className = 'pill-finder__grid-thumb';
      var thumbImg = document.createElement('img');
      thumbImg.alt = '';
      thumbImg.loading = 'lazy';
      thumbEl.appendChild(thumbImg);
      item.appendChild(thumbEl);

      var textWrap = document.createElement('div');
      textWrap.className = 'pill-finder__grid-text';

      var nameRow = document.createElement('div');
      nameRow.className = 'pill-finder__grid-name-row';
      var nameEl = document.createElement('span');
      nameEl.className = 'pill-finder__grid-name';
      nameEl.textContent = t.trigger;
      nameRow.appendChild(nameEl);
      textWrap.appendChild(nameRow);

      var enr = enriched && enriched[t.handle];
      if (enr) {
        if (enr.title) nameEl.textContent = enr.title;
        if (enr.image) {
          thumbImg.src = enr.image;
          thumbImg.alt = enr.title || t.trigger;
        }
        if (enr.wirkstoff) {
          var metaEl = document.createElement('span');
          metaEl.className = 'pill-finder__grid-meta';
          metaEl.textContent = enr.wirkstoff;
          textWrap.appendChild(metaEl);
        }
        var picked = pickCheapestSellable(enr.variants);
        if (picked.cheapest != null) {
          self.priceCache[t.handle] = picked.cheapest;
          var priceEl = document.createElement('span');
          priceEl.className = 'pill-finder__grid-price';
          priceEl.textContent = (picked.count > 1 ? 'ab ' : '') + formatEuro(picked.cheapest);
          textWrap.appendChild(priceEl);
        }
      }

      if (!enr || !enr.image) {
        (function(handle, imgEl, titleEl) {
          fetch('/products/' + handle + '.json')
            .then(function(resp) { return resp.ok ? resp.json() : null; })
            .then(function(data) {
              if (data && data.product && data.product.images && data.product.images.length > 0) {
                imgEl.src = data.product.images[0].src;
                imgEl.alt = data.product.title;
              }
              if (data && data.product && data.product.title) titleEl.textContent = data.product.title;
            })
            .catch(function() {});
        })(t.handle, thumbImg, nameEl);
      }

      item.appendChild(textWrap);
      item.addEventListener('click', function() { navigateToVariant(t.handle); });
      cell.appendChild(item);

      if (t.alternatives && t.alternatives.length > 0) {
        var altWrap = document.createElement('div');
        altWrap.className = 'pill-finder__grid-alts';
        var altLabel = document.createElement('span');
        altLabel.className = 'pill-finder__result-alts-label pill-finder__grid-alts-caption';
        altLabel.textContent = ui.alternativesLabel;
        altWrap.appendChild(altLabel);
        t.alternatives.forEach(function(alt) {
          var altBtn = document.createElement('button');
          altBtn.type = 'button';
          altBtn.className = 'pill-finder__alt-btn';
          altBtn.textContent = alt.title;
          altBtn.dataset.handle = alt.handle;
          altBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            navigateToVariant(alt.handle);
          });
          altWrap.appendChild(altBtn);
        });
        cell.appendChild(altWrap);
      }

      grid.appendChild(cell);
    });

    if (filtered.length === 0) {
      var empty = document.createElement('p');
      empty.className = 'pill-finder__grid-empty';
      empty.textContent = ui.emptyFilter;
      grid.appendChild(empty);
    }
  };

  SearchInstance.prototype.init = function() {
    this.cacheElements();
    if (!this._el.root) return;
    var self = this;
    var el = self._el;

    self.enrichFiltersFromAPI(function() {
      if (el.input && el.input.value.length >= 2) {
        self.loadTriggerData(function(data) {
          self.renderResults(self.searchTriggers(el.input.value, data.triggers));
        });
      }
    });

    if (el.input) {
      el.input.addEventListener('input', function() {
        clearTimeout(self._timer);
        var val = el.input.value;
        self._timer = setTimeout(function() {
          if (val.length < 2) {
            el.results.hidden = true;
            el.results.innerHTML = '';
            el.status.textContent = '';
            return;
          }
          self.loadTriggerData(function(data) {
            var results = self.searchTriggers(val, data.triggers);
            self.renderResults(results);
          });
        }, 200);
      });
    }

    if (el.filterToggle) {
      el.filterToggle.addEventListener('click', function() {
        self.isFilterView = !self.isFilterView;
        el.filterToggle.setAttribute('aria-expanded', self.isFilterView ? 'true' : 'false');
        el.filterZone.hidden = !self.isFilterView;
        if (self.isFilterView) {
          el.results.hidden = true;
          if (el.input) el.input.value = '';
          self.loadTriggerData(function(data) {
            function syncFilterUi() {
              self.populateFilters(data.triggers, self.enrichedData);
              self.updateFilterSelects(self.enrichedData, data.triggers);
              self.renderFilterGrid(data.triggers);
            }
            syncFilterUi();
            if (!self.enrichedData || Object.keys(self.enrichedData).length === 0) {
              self.enrichFiltersFromAPI(function() {
                syncFilterUi();
              });
            }
          });
        }
      });
    }

    if (el.searchWrap) {
      el.searchWrap.addEventListener('change', function(e) {
        var filterType = e.target.dataset && e.target.dataset.filter;
        if (!filterType) return;
        if (filterType === 'wirkstoff' && e.target.type === 'checkbox') {
          self.syncWirkstoffSubstanceKeysFromDom();
          self.updateMultiDropdownSummaryDom('wirkstoff');
          self.loadTriggerData(function(data) { self.renderFilterGrid(data.triggers); });
          return;
        }
        if (filterType === 'darreichungsform' && e.target.type === 'checkbox') {
          self.syncDarreichungsformValuesFromDom();
          self.updateMultiDropdownSummaryDom('darreichungsform');
          self.loadTriggerData(function(data) { self.renderFilterGrid(data.triggers); });
          return;
        }
        if (filterType === 'sort' && e.target.type === 'radio') {
          self.activeFilters.sort = e.target.value;
          self.updateMultiDropdownSummaryDom('sort');
          self.loadTriggerData(function(data) { self.renderFilterGrid(data.triggers); });
          return;
        }
      });

      el.searchWrap.addEventListener('click', function(e) {
        var azBtn = e.target.closest('.pill-finder__az-btn');
        if (!azBtn || azBtn.disabled) return;
        var letter = azBtn.dataset.letter;
        if (self.activeFilters.letter === letter) {
          self.activeFilters.letter = '';
          azBtn.classList.remove('pill-finder__az-btn--active');
        } else {
          el.searchWrap.querySelectorAll('.pill-finder__az-btn').forEach(function(b) {
            b.classList.remove('pill-finder__az-btn--active');
          });
          self.activeFilters.letter = letter;
          azBtn.classList.add('pill-finder__az-btn--active');
        }
        self.loadTriggerData(function(data) { self.renderFilterGrid(data.triggers); });
      });
    }
  };

  var instances = {};

  window.PillSearchEngine = {
    init: function(sectionId) {
      if (instances[sectionId]) return instances[sectionId];
      var instance = new SearchInstance(sectionId);
      instances[sectionId] = instance;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() { instance.init(); });
      } else {
        instance.init();
      }
      return instance;
    },
    formatEuro: formatEuro,
    navigateToVariant: navigateToVariant
  };
})();
